module.exports = __webpack_public_path__ + "static/media/cancel.79eb87b4.svg";